<template>
    <div class="flex items-center justify-center justify-between ml-3">
        <span
            class="flex-1 mt-2 mr-5 text-base font-light leading-9 text-left text-blue-600"
            >{{ title }}</span
        >
        <div class="flex-1 mx-8 w-28">
            <base-number-input
                currency="DH/m²"
                :isCurrency="true"
                placeholder="DH"
                v-model="input"
                :hasError="priceError.$error"
                :errorMessage="errorMessage('Prix', priceError)"
                @blur="priceError.$touch()"
            />
        </div>
        <div class="flex-1 mx-8 w-28">
            <base-number-input
                :placeholder="
                    title === 'Mur de clôture en dur'
                        ? placeholder2
                        : placeholder1
                "
                v-model="input2"
                :hasError="surfaceError.$error"
                :errorMessage="errorMessage('Surface', surfaceError)"
                @blur="surfaceError.$touch()"
            />
        </div>
        <span
            class="flex-1 mt-5 mr-5 text-base font-light leading-9 text-left text-blue-600"
            >{{ limite }}</span
        >
    </div>
</template>

<script>
import { errorMessage } from "@/mixins/errorMessage.js";

export default {
    mixins: [errorMessage],
    props: {
        title: {
            type: String,
            required: true
        },

        value: {
            required: true
        },
        value2: {
            required: true
        },
        limite: {
            type: String,
            required: true
        },
        placeholder1: {
            type: String,
            default: "Superficie (m²)"
        },
        placeholder2: {
            type: String,
            default: "m/l"
        },
        priceError: {
            type: Object,
            required: true
        },
        surfaceError: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            errorClass:
                " border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red ",
            activeClass: "border-gray-500"
        };
    },
    computed: {
        input: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        },
        input2: {
            get() {
                return this.value2;
            },
            set(val) {
                this.$emit("input2", val);
            }
        }
    }
};
</script>

<style></style>
